"use client";
import React from "react";
import { TracingBeam } from "../ui/tracing-beam.tsx";
import Footer from "../myComponents/Footer.js";

export function TracingBeamDemo({children}) {
  return (
    <>
    <TracingBeam className="">
        {children}
    </TracingBeam>
    <Footer/>
    </>

  );
}
